/**
 * The widget's own CSS, scoped via the .uq- prefix and injected into a
 * Shadow DOM root to avoid colliding with the host site's styles.
 */
export const WIDGET_CSS = `
:host { all: initial; }
* { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif; }

.uq-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px; height: 56px;
  border-radius: 50%;
  background: var(--uq-accent, #4f46e5);
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0,0,0,0.25);
  display: flex; align-items: center; justify-content: center;
  z-index: 2147483646;
  transition: transform 0.2s ease;
}
.uq-toggle:hover { transform: scale(1.06); }
.uq-toggle:focus-visible { outline: 3px solid #fff; outline-offset: 2px; }
.uq-toggle svg { width: 28px; height: 28px; }

.uq-panel {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 340px;
  max-height: calc(100vh - 120px);
  background: #fff;
  color: #111;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.22);
  z-index: 2147483647;
  display: none;
  flex-direction: column;
  overflow: hidden;
  animation: uq-in 0.18s ease-out;
}
.uq-panel.uq-open { display: flex; }
@keyframes uq-in { from { transform: translateY(8px); opacity: 0; } to { transform: none; opacity: 1; } }

.uq-header {
  padding: 16px;
  background: var(--uq-accent, #4f46e5);
  color: white;
  display: flex; align-items: center; justify-content: space-between;
}
.uq-header h2 { margin: 0; font-size: 16px; font-weight: 600; }
.uq-header button {
  background: transparent; border: none; color: white;
  cursor: pointer; padding: 4px; border-radius: 4px;
}
.uq-header button:hover { background: rgba(255,255,255,0.15); }

.uq-body { padding: 12px; overflow-y: auto; }
.uq-tool {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 12px; border-radius: 10px; margin-bottom: 4px;
  cursor: pointer; user-select: none;
}
.uq-tool:hover { background: #f5f5f7; }
.uq-tool[aria-pressed="true"] { background: #eef2ff; color: #4338ca; }
.uq-tool-label { font-size: 14px; }
.uq-tool-state { font-size: 12px; color: #6b7280; }

.uq-row { display: flex; gap: 8px; padding: 10px 12px; align-items: center; }
.uq-row button {
  flex: 1; padding: 8px; border: 1px solid #e5e7eb; background: #fff;
  border-radius: 8px; cursor: pointer; font-size: 14px;
}
.uq-row button:hover { background: #f9fafb; }
.uq-row span { font-size: 14px; min-width: 40px; text-align: center; }

.uq-footer {
  padding: 10px 16px;
  border-top: 1px solid #f0f0f3;
  display: flex; justify-content: space-between; align-items: center;
  font-size: 11px; color: #6b7280;
}
.uq-footer button {
  background: transparent; border: none; color: #4f46e5;
  cursor: pointer; font-size: 12px;
}
.uq-footer a { color: #6b7280; text-decoration: none; }

/* Barrier report section */
.uq-barrier { padding: 10px 12px 4px; border-top: 1px solid #f0f0f3; margin-top: 4px; }
.uq-barrier-btn {
  width: 100%; background: transparent; border: 1px solid #e5e7eb; border-radius: 8px;
  padding: 10px 12px; font-size: 13px; cursor: pointer; color: #374151;
  text-align: left; transition: background 0.12s;
}
.uq-barrier-btn:hover { background: #f5f5f7; }
.uq-barrier-title { font-size: 13px; font-weight: 600; margin: 4px 0 8px; color: #111; }
.uq-barrier-desc, .uq-barrier-email {
  display: block; width: 100%; border: 1px solid #e5e7eb; border-radius: 8px;
  padding: 8px 10px; font-size: 13px; margin-bottom: 8px;
  font-family: inherit; color: #111; background: #fff;
}
.uq-barrier-desc { resize: vertical; min-height: 70px; }
.uq-barrier-desc:focus, .uq-barrier-email:focus {
  outline: 2px solid var(--uq-accent, #4f46e5); border-color: transparent;
}
.uq-barrier-actions { display: flex; gap: 8px; margin-bottom: 8px; }
.uq-barrier-cancel {
  flex: 1; padding: 8px; border: 1px solid #e5e7eb; background: #fff;
  border-radius: 8px; font-size: 13px; cursor: pointer;
}
.uq-barrier-submit {
  flex: 2; padding: 8px; border: none;
  background: var(--uq-accent, #4f46e5); color: #fff;
  border-radius: 8px; font-size: 13px; cursor: pointer; font-weight: 600;
}
.uq-barrier-submit:hover { opacity: 0.9; }
.uq-barrier-submit:disabled, .uq-barrier-cancel:disabled { opacity: 0.6; cursor: not-allowed; }
.uq-barrier-msg { font-size: 13px; text-align: center; padding: 10px 0; }
.uq-barrier-msg.ok { color: #059669; font-weight: 500; }
.uq-barrier-msg.err { color: #ef4444; margin-bottom: 8px; font-size: 12px; }

/* Accessibility profiles — one-tap presets */
.uq-profiles {
  display: flex; flex-wrap: wrap; gap: 6px;
  padding: 4px 12px 10px; border-bottom: 1px solid #f0f0f3; margin-bottom: 8px;
}
.uq-profile {
  border: 1px solid #e5e7eb; background: #fff; color: #374151;
  border-radius: 999px; padding: 6px 12px; font-size: 12px; cursor: pointer;
}
.uq-profile:hover { background: #f5f5f7; }
.uq-profile[aria-pressed="true"] { background: var(--uq-accent, #4f46e5); color: #fff; border-color: transparent; }
.uq-profile:focus-visible { outline: 2px solid var(--uq-accent, #4f46e5); outline-offset: 2px; }
.uq-section-label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: #9ca3af; padding: 4px 12px; }

/* The widget must obey the visitor's own motion preference. */
@media (prefers-reduced-motion: reduce) {
  .uq-toggle { transition: none; }
  .uq-toggle:hover { transform: none; }
  .uq-panel { animation: none; }
}
`;

/**
 * Styles applied to the *host page* when a tool is active. Lives in a
 * regular <style> tag (Shadow DOM can't reach outside).
 */
export const HOST_CSS = `
html.uq-high-contrast, html.uq-high-contrast body { background: #000 !important; color: #fff !important; }
html.uq-high-contrast *:not(.uq-no-cascade) { background-color: #000 !important; color: #fff !important; border-color: #fff !important; }
html.uq-high-contrast a, html.uq-high-contrast a * { color: #ffeb3b !important; }
html.uq-high-contrast img, html.uq-high-contrast video { filter: none !important; }

html.uq-dark-mode, html.uq-dark-mode body { background: #1a1a1a !important; color: #f0f0f0 !important; }
html.uq-dark-mode *:not(.uq-no-cascade) { background-color: transparent !important; color: #f0f0f0 !important; }
html.uq-dark-mode a, html.uq-dark-mode a * { color: #93c5fd !important; }

html.uq-dyslexia, html.uq-dyslexia * { font-family: "OpenDyslexic", "Comic Sans MS", Arial, sans-serif !important; letter-spacing: 0.05em !important; }

html.uq-readable, html.uq-readable * { font-family: Arial, Helvetica, sans-serif !important; }

html.uq-big-cursor, html.uq-big-cursor * { cursor: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 24 24' fill='black' stroke='white' stroke-width='1'><path d='M3 2l7 18 2-8 8-2z'/></svg>") 0 0, auto !important; }

html.uq-links-highlight a {
  outline: 2px solid #4f46e5 !important;
  outline-offset: 2px !important;
  background: #eef2ff !important;
  color: #1e1b4b !important;
}

html.uq-focus-rings *:focus {
  outline: 3px solid #f59e0b !important;
  outline-offset: 3px !important;
}

html.uq-stop-animations, html.uq-stop-animations *, html.uq-stop-animations *::before, html.uq-stop-animations *::after {
  animation-duration: 0.001ms !important;
  animation-iteration-count: 1 !important;
  transition-duration: 0.001ms !important;
  scroll-behavior: auto !important;
}

html[data-uq-font-scale] body { font-size: calc(1em * var(--uq-font-scale, 1)) !important; }

html.uq-text-spacing, html.uq-text-spacing * {
  line-height: 1.8 !important;
  letter-spacing: 0.12em !important;
  word-spacing: 0.16em !important;
}

html.uq-hide-images img,
html.uq-hide-images picture,
html.uq-hide-images svg:not(.uq-no-cascade),
html.uq-hide-images video {
  visibility: hidden !important;
}

html.uq-highlight-headings h1,
html.uq-highlight-headings h2,
html.uq-highlight-headings h3,
html.uq-highlight-headings h4,
html.uq-highlight-headings h5,
html.uq-highlight-headings h6 {
  outline: 2px solid #f59e0b !important;
  outline-offset: 2px !important;
  background: rgba(245, 158, 11, 0.12) !important;
}

.uq-reading-guide {
  position: fixed; left: 0; right: 0; height: 40px;
  background: rgba(0,0,0,0.5); pointer-events: none;
  z-index: 2147483645;
  border-top: 1px solid rgba(255,255,255,0.4);
  border-bottom: 1px solid rgba(255,255,255,0.4);
}

/* Screen reader mode — skip link floats above page, visible on focus */
.uq-skip-link {
  position: fixed !important;
  top: -100px;
  left: 10px;
  z-index: 2147483647;
  background: #4f46e5;
  color: #fff !important;
  padding: 10px 18px;
  border-radius: 0 0 8px 8px;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none !important;
  transition: top 0.15s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}
.uq-skip-link:focus {
  top: 0 !important;
  outline: 3px solid #fbbf24 !important;
  outline-offset: 2px !important;
}

html.uq-screen-reader *:focus {
  outline: 3px solid #4f46e5 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 6px rgba(79,70,229,0.18) !important;
}
html.uq-screen-reader a { text-decoration: underline !important; }
html.uq-screen-reader img[alt=""], html.uq-screen-reader img:not([alt]) {
  outline: 2px dashed #f59e0b !important;
  outline-offset: 2px !important;
}
`;
